import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
    iconfont: "fa",
    theme: {
        dark: false,
        themes: {
            light: {
                primary: "#3F51B5",
                primary_dark: "#303F9F",
                secondary: "#673AB7",
                accent: "#607D8B",
                success: "#4CAF50",
                warning: "#FFC107",
                info: "#2196F3",
                error: "#FF5252",
            },
        },
    },
});
